export const themeTokens = {
    light: {
        headerBg: 'bg-white',
        scrolledHeaderBg: 'bg-white/90 backdrop-blur-[3px]',
        textPrimary: 'text-gray-900',
        textSecondary: 'text-gray-700',
        textMuted: 'text-gray-500',
        linkPrimary: 'text-gray-900',
        linkSecondary: 'text-gray-700',
        hoverBg: 'hover:bg-gray-50',
        activeBg: 'bg-gray-100',
        dropdownBg: 'bg-white',
        border: 'border-gray-200',
        overlay: 'bg-black/30 backdrop-blur-sm',
        searchBg: 'bg-gray-100',
        searchPlaceholder: 'placeholder:text-gray-500',
        utilityBg: 'bg-gray-50',
        ctaBg: 'bg-gray-900',
        ctaText: 'text-white',
        ctaHover: 'hover:bg-black',
    },
    dark: {
        headerBg: 'bg-black',
        scrolledHeaderBg: 'bg-black/90 backdrop-blur-[3px]',
        textPrimary: 'text-white',
        textSecondary: 'text-gray-200',
        textMuted: 'text-gray-400',
        linkPrimary: 'text-white',
        linkSecondary: 'text-gray-300',
        hoverBg: 'hover:bg-white/10',
        activeBg: 'bg-white/10',
        dropdownBg: 'bg-black',
        border: 'border-white/10',
        overlay: 'bg-black/40 backdrop-blur-md',
        searchBg: 'bg-white/10',
        searchPlaceholder: 'placeholder:text-gray-400',
        utilityBg: 'bg-white/[0.03]',
        ctaBg: 'bg-white',
        ctaText: 'text-black',
        ctaHover: 'hover:bg-gray-200',
    },
};

export const layoutTokens = {
    md: {
        desktopContentWidth: 'md:max-w-4xl',
        desktopContentPadding: 'px-4 sm:px-6 lg:px-8',
    },
    lg: {
        desktopContentWidth: 'md:max-w-6xl',
        desktopContentPadding: 'px-4 sm:px-6 lg:px-8',
    },
    xl: {
        desktopContentWidth: 'md:max-w-7xl',
        desktopContentPadding: 'px-4 sm:px-6 lg:px-10',
    },
    full: {
        desktopContentWidth: 'w-full',
        desktopContentPadding: 'px-4 sm:px-6 lg:px-12',
    },
} as const;

export const logoLayoutTokens = {
    default: {
        mainBarMinHeight: 'min-h-16',
        desktopLogoHeight: 'h-10',
        mobileLogoHeight: 'h-10',
    },
    compact: {
        mainBarMinHeight: 'min-h-14',
        desktopLogoHeight: 'h-12',
        mobileLogoHeight: 'h-12',
    },
} as const;

export const topLevelLinkStyleTokens = {
    light: {
        link: {
            color: '#111827',
            textDecoration: 'none',
            fontSize: '13px',
            fontWeight: 600,
            lineHeight: 1.15,
            backgroundColor: 'transparent',
        },
        label: {
            color: 'inherit',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
        },
        activeUnderline: {
            borderBottomColor: 'currentColor',
            color: '#111827',
        },
        activeBackground: {
            backgroundColor: '#f3f4f6',
            color: '#111827',
            boxShadow: 'inset 0 0 0 1px rgba(17, 24, 39, 0.06)',
        },
    },
    dark: {
        link: {
            color: '#f9fafb',
            textDecoration: 'none',
            fontSize: '13px',
            fontWeight: 600,
            lineHeight: 1.15,
            backgroundColor: 'transparent',
        },
        label: {
            color: 'inherit',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
        },
        activeUnderline: {
            borderBottomColor: 'currentColor',
            color: '#ffffff',
        },
        activeBackground: {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            color: '#ffffff',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.12)',
        },
    },
} as const;
